/* Eczema - 02 - Optimise Search start */
(function () {
    var overlay = document.getElementById("eq-search-overlay");
    if (!overlay) return;

    var configEl = document.getElementById("eq-search-overlay-config");
    var config = {};
    try {
        config = configEl ? JSON.parse(configEl.textContent) : {};
    } catch (e) {
        config = {};
    }

    var openButtons = document.querySelectorAll(".js-eq-search-open");
    var closeButtons = document.querySelectorAll(".js-eq-search-close");
    var input = overlay.querySelector(".js-eq-search-input");
    var resultsEl = overlay.querySelector(".js-eq-search-results");
    var idleEl = overlay.querySelector(".js-eq-search-idle");
    var popularEl = overlay.querySelector(".js-eq-search-popular");
    var headerEl = document.querySelector(".eq-header");
    var cartIconEl = document.querySelector(".eq-header__cart-icon");
    var closeBtnEl = overlay.querySelector(".eq-search-overlay__close");
    var clearBtnEl = overlay.querySelector(".js-eq-search-clear");
    var inputWrapEl = overlay.querySelector(".eq-search-overlay__input-wrap");
    var searchIconEl = overlay.querySelector(".eq-search-overlay__icon");
    var searchUrl = config.searchUrl || (window.theme && theme.routes && theme.routes.search_url) || "/search";
    var moneyFormat = config.moneyFormat || (window.theme && theme.moneyFormat) || (window.Shopify && Shopify.money_format) || "£{{amount}}";
    var labels = Object.assign(
        {
            suggestions: "Suggestions",
            products: "Products",
            viewAll: "View all results",
            empty: "No products found",
            sale: "Sale",
        },
        config.labels || {},
    );
    var curatedTerms = (config.suggestionTerms || [])
        .map(function (term) {
            return String(term || "").trim();
        })
        .filter(Boolean);
    var debounceTimer = null;
    var activeRequest = null;
    var lastFocused = null;
    var lockedScrollY = 0;
    var scrollCapturedOnTouch = false;
    var isTypingInSearch = false;
    var panelEl = overlay.querySelector(".eq-search-overlay__panel");
    var backdropEl = overlay.querySelector(".eq-search-overlay__backdrop");
    var MAX_PRODUCT_SUGGESTIONS = 4;

    function resetStuckScrollLock() {
        document.documentElement.classList.remove("eq-search-open", "eq-search-typing");
        document.body.classList.remove("eq-search-open", "eq-search-typing");
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
    }

    resetStuckScrollLock();

    function escapeHtml(value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function escapeRegExp(value) {
        return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function titleCase(value) {
        return String(value)
            .split(/\s+/)
            .filter(Boolean)
            .map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(" ");
    }

    function formatMoneyValue(raw) {
        if (raw == null || raw === "") return "";

        if (typeof raw === "string" && raw.indexOf(".") !== -1) {
            if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === "function") {
                return theme.Shopify.formatMoney(raw, moneyFormat);
            }
            return "£" + raw;
        }

        if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === "function") {
            return theme.Shopify.formatMoney(raw, moneyFormat);
        }
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
            return Shopify.formatMoney(raw, moneyFormat);
        }

        return "£" + (Number(raw) / 100).toFixed(2);
    }

    function renderPriceHtml(product) {
        var priceRaw = product.price_min != null ? product.price_min : product.price;
        var compareRaw = product.compare_at_price_min != null ? product.compare_at_price_min : product.compare_at_price;
        var price = parseFloat(priceRaw);
        var compare = parseFloat(compareRaw);
        var onSale = !isNaN(compare) && !isNaN(price) && compare > price;

        if (onSale) {
            return (
                '<span class="eq-search-overlay__price">' +
                escapeHtml(formatMoneyValue(priceRaw)) +
                "</span>" +
                '<s class="eq-search-overlay__compare">' +
                escapeHtml(formatMoneyValue(compareRaw)) +
                "</s>"
            );
        }

        return '<span class="eq-search-overlay__price">' + escapeHtml(formatMoneyValue(priceRaw)) + "</span>";
    }

    function isOnSale(product) {
        var price = parseFloat(product.price_min != null ? product.price_min : product.price);
        var compare = parseFloat(product.compare_at_price_min != null ? product.compare_at_price_min : product.compare_at_price);
        return !isNaN(compare) && !isNaN(price) && compare > price;
    }

    function highlightSuggestion(text, query) {
        var q = String(query || "").trim();
        if (!q) return escapeHtml(text);

        var lowerText = text.toLowerCase();
        var lowerQ = q.toLowerCase();
        var idx = lowerText.indexOf(lowerQ);
        if (idx === -1) return escapeHtml(text);

        var matched = text.slice(idx, idx + q.length);
        var before = text.slice(0, idx);
        var after = text.slice(idx + q.length);

        if (!after) {
            return escapeHtml(before) + '<span class="eq-search-overlay__suggest-match">' + escapeHtml(matched) + "</span>";
        }

        return (
            escapeHtml(before) +
            '<span class="eq-search-overlay__suggest-match">' +
            escapeHtml(matched) +
            "</span>" +
            '<span class="eq-search-overlay__suggest-rest">' +
            escapeHtml(after) +
            "</span>"
        );
    }

    function pushUnique(list, seen, value) {
        var cleaned = String(value || "")
            .replace(/\s+/g, " ")
            .trim();
        if (!cleaned) return;
        var key = cleaned.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        list.push(cleaned);
    }

    function buildQuerySuggestions(term, products) {
        var suggestions = [];
        var seen = {};
        var q = term.trim().toLowerCase();
        if (!q) return suggestions;

        curatedTerms.forEach(function (item) {
            var lower = item.toLowerCase();
            if (lower === q) return;
            if (lower.indexOf(q) === 0 || lower.indexOf(" " + q) !== -1 || lower.indexOf(q) !== -1) {
                pushUnique(suggestions, seen, titleCase(item));
            }
        });

        (products || []).forEach(function (product) {
            var title = product.title || "";
            var lowerTitle = title.toLowerCase();
            var idx = lowerTitle.indexOf(q);
            if (idx === -1) return;

            var fromMatch = title.slice(idx).replace(/[–—]/g, " ").trim();
            var words = fromMatch.split(/\s+/).filter(Boolean);

            if (words.length >= 2) {
                pushUnique(suggestions, seen, titleCase(words.slice(0, 2).join(" ")));
            } else if (words.length === 1) {
                var type = String(product.type || "")
                    .replace(/^(adult|kids|women'?s|men'?s)\s+/i, "")
                    .trim();
                var typeWord = type.split(/\s+/)[0];
                if (typeWord && typeWord.toLowerCase() !== q) {
                    pushUnique(suggestions, seen, titleCase(words[0] + " " + typeWord));
                }
            }

            // Also suggest query + first meaningful word from type when title match is weak
            if (product.type) {
                var typeParts = String(product.type)
                    .replace(/^(adult|kids|women'?s|men'?s)\s+/i, "")
                    .split(/\s+/)
                    .filter(Boolean);
                if (typeParts[0] && typeParts[0].toLowerCase() !== q) {
                    pushUnique(suggestions, seen, titleCase(q + " " + typeParts[0]));
                }
            }
        });

        return suggestions.slice(0, 6);
    }

    function syncMobileBackdrop() {
        if (!backdropEl) return;
        if (!shouldUseFixedScrollLock() || overlay.hidden || !panelEl) {
            backdropEl.style.removeProperty("top");
            backdropEl.style.removeProperty("right");
            backdropEl.style.removeProperty("bottom");
            backdropEl.style.removeProperty("left");
            backdropEl.style.removeProperty("width");
            backdropEl.style.removeProperty("height");
            document.documentElement.style.removeProperty("--eq-search-backdrop-top");
            return;
        }
        var panelBottom = Math.max(0, Math.round(panelEl.getBoundingClientRect().bottom));
        backdropEl.style.setProperty("top", panelBottom + "px", "important");
        backdropEl.style.setProperty("right", "0", "important");
        backdropEl.style.setProperty("bottom", "0", "important");
        backdropEl.style.setProperty("left", "0", "important");
        backdropEl.style.setProperty("width", "auto", "important");
        backdropEl.style.setProperty("height", "auto", "important");
        document.documentElement.style.setProperty("--eq-search-backdrop-top", panelBottom + "px");
    }

    function syncOverlayLayout() {
        syncOverlayTop();
        syncSearchControls();
        syncMobileBackdrop();
    }

    function scheduleOverlayLayoutSync() {
        syncOverlayLayout();
        window.requestAnimationFrame(function () {
            syncOverlayLayout();
        });
    }

    function syncOverlayTop() {
        if (!headerEl) {
            overlay.style.top = "0px";
            document.documentElement.style.setProperty("--eq-search-overlay-top", "0px");
            return;
        }
        var bottom = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
        overlay.style.top = bottom + "px";
        document.documentElement.style.setProperty("--eq-search-overlay-top", bottom + "px");
    }

    function isDesktopSearchControls() {
        return window.matchMedia("(min-width: 992px)").matches;
    }

    function resetSearchControlPosition() {
        if (closeBtnEl) {
            closeBtnEl.style.removeProperty("position");
            closeBtnEl.style.removeProperty("left");
            closeBtnEl.style.removeProperty("top");
            closeBtnEl.style.removeProperty("right");
            closeBtnEl.style.removeProperty("transform");
        }
        if (clearBtnEl) {
            clearBtnEl.style.removeProperty("position");
            clearBtnEl.style.removeProperty("left");
            clearBtnEl.style.removeProperty("top");
            clearBtnEl.style.removeProperty("right");
            clearBtnEl.style.removeProperty("transform");
        }
    }

    function syncCloseToCart() {
        if (!closeBtnEl || !inputWrapEl) return;
        if (!isDesktopSearchControls()) {
            resetSearchControlPosition();
            return;
        }
        if (!cartIconEl) return;
        var cartRect = cartIconEl.getBoundingClientRect();
        var wrapRect = inputWrapEl.getBoundingClientRect();
        var btnWidth = closeBtnEl.offsetWidth || 24;
        var cartCenter = cartRect.left + cartRect.width / 2;
        var left = Math.round(cartCenter - wrapRect.left - btnWidth / 2);
        var maxLeft = Math.max(0, wrapRect.width - btnWidth);
        if (left < 0) left = 0;
        if (left > maxLeft) left = maxLeft;
        closeBtnEl.style.setProperty("position", "absolute", "important");
        closeBtnEl.style.setProperty("left", left + "px", "important");
        closeBtnEl.style.setProperty("top", "50%", "important");
        closeBtnEl.style.setProperty("right", "auto", "important");
        closeBtnEl.style.setProperty("transform", "translateY(-50%)", "important");
    }

    function updateClearVisibility() {
        if (!clearBtnEl || !input) return;
        clearBtnEl.hidden = input.value.length === 0;
    }

    function resetClearPosition() {
        if (!clearBtnEl) return;
        clearBtnEl.hidden = true;
        clearBtnEl.style.removeProperty("position");
        clearBtnEl.style.removeProperty("left");
        clearBtnEl.style.removeProperty("top");
        clearBtnEl.style.removeProperty("right");
        clearBtnEl.style.removeProperty("transform");
    }

    function syncClearPosition() {
        if (!clearBtnEl || clearBtnEl.hidden || !closeBtnEl) return;
        if (!isDesktopSearchControls()) return;
        var closeLeft = parseFloat(closeBtnEl.style.left);
        if (isNaN(closeLeft)) return;
        var clearWidth = clearBtnEl.offsetWidth || 60;
        var gap = 16;
        clearBtnEl.style.setProperty("position", "absolute", "important");
        clearBtnEl.style.setProperty("left", Math.round(closeLeft - clearWidth - gap) + "px", "important");
        clearBtnEl.style.setProperty("top", "50%", "important");
        clearBtnEl.style.setProperty("right", "auto", "important");
        clearBtnEl.style.setProperty("transform", "translateY(-50%)", "important");
    }

    function syncSearchControls() {
        syncCloseToCart();
        updateClearVisibility();
        syncClearPosition();
    }

    function clearSearchInput() {
        if (!input) return;
        input.value = "";
        resetClearPosition();
        if (clearBtnEl) clearBtnEl.blur();
        showIdleSuggestions();
        if (activeRequest && typeof activeRequest.abort === "function") {
            activeRequest.abort();
            activeRequest = null;
        }
        input.focus();
    }

    function setTypingState(isTyping) {
        isTypingInSearch = isTyping;
        document.documentElement.classList.toggle("eq-search-typing", isTyping);
        document.body.classList.toggle("eq-search-typing", isTyping);
        overlay.classList.toggle("eq-search-typing", isTyping);
    }

    function preventTouchMoveWhileOpen(event) {
        if (overlay.hidden) return;
        if (isTypingInSearch) {
            if (panelEl && panelEl.contains(event.target)) return;
            event.preventDefault();
            return;
        }
        if (panelEl && panelEl.contains(event.target)) return;
        event.preventDefault();
    }

    function initScrollToBlurInput() {
        if (!panelEl || !input) return;

        var touchStartY = null;
        var SCROLL_BLUR_THRESHOLD = 10;

        panelEl.addEventListener(
            "touchstart",
            function (event) {
                if (!shouldUseFixedScrollLock() || overlay.hidden || !isTypingInSearch) return;
                if (event.touches.length === 1) {
                    touchStartY = event.touches[0].clientY;
                }
            },
            { passive: true, capture: true },
        );

        panelEl.addEventListener(
            "touchmove",
            function (event) {
                if (!shouldUseFixedScrollLock() || overlay.hidden || !isTypingInSearch || touchStartY == null) return;
                if (event.touches.length !== 1) return;
                if (Math.abs(event.touches[0].clientY - touchStartY) >= SCROLL_BLUR_THRESHOLD) {
                    touchStartY = null;
                    input.blur();
                }
            },
            { passive: true, capture: true },
        );

        panelEl.addEventListener(
            "touchend",
            function () {
                touchStartY = null;
            },
            { passive: true, capture: true },
        );

        panelEl.addEventListener(
            "touchcancel",
            function () {
                touchStartY = null;
            },
            { passive: true, capture: true },
        );

        panelEl.addEventListener(
            "wheel",
            function () {
                if (!shouldUseFixedScrollLock() || overlay.hidden || !isTypingInSearch) return;
                input.blur();
            },
            { passive: true },
        );
    }

    function shouldUseFixedScrollLock() {
        return window.matchMedia("(max-width: 991px)").matches;
    }

    function lockBodyScroll() {
        if (!shouldUseFixedScrollLock()) return;
        // Prefer the value captured on touchstart; fall back to current scroll.
        if (typeof lockedScrollY !== "number" || isNaN(lockedScrollY)) {
            lockedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        }
        // Set top + position together before paint so the page does not flash to the top.
        document.body.style.top = "0";
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
        document.body.style.position = "fixed";
        document.documentElement.classList.add("eq-search-open");
        document.body.classList.add("eq-search-open");
        document.addEventListener("touchmove", preventTouchMoveWhileOpen, { passive: false });
    }

    function unlockBodyScroll() {
        setTypingState(false);
        var wasFixed = document.body.style.position === "fixed";
        document.documentElement.classList.remove("eq-search-open");
        document.body.classList.remove("eq-search-open");
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
        document.removeEventListener("touchmove", preventTouchMoveWhileOpen, { passive: false });
        syncMobileBackdrop();
        if (wasFixed) {
            window.scrollTo(0, lockedScrollY);
        }
    }

    function setOpenState(isOpen) {
        if (isOpen) {
            // Freeze scroll first, then reveal overlay — avoids a one-frame jump/flicker.
            lockBodyScroll();
            overlay.hidden = false;
            overlay.setAttribute("aria-hidden", "false");
            syncOverlayLayout();
            window.requestAnimationFrame(syncOverlayLayout);
        } else {
            overlay.hidden = true;
            overlay.setAttribute("aria-hidden", "true");
            unlockBodyScroll();
            overlay.style.top = "";
            document.documentElement.style.removeProperty("--eq-search-overlay-top");
            document.documentElement.style.removeProperty("--eq-search-backdrop-top");
            resetSearchControlPosition();
            resetClearPosition();
        }
        openButtons.forEach(function (btn) {
            btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });
    }

    function hideSuggestionPanels() {
        if (resultsEl) {
            resultsEl.innerHTML = "";
            resultsEl.hidden = true;
            resultsEl.classList.remove("eq-search-overlay__results--active");
        }
        if (idleEl) idleEl.hidden = true;
        overlay.classList.remove("eq-search-overlay--suggestions-visible");
    }

    function showIdleSuggestions() {
        if (resultsEl) {
            resultsEl.innerHTML = "";
            resultsEl.hidden = true;
            resultsEl.classList.remove("eq-search-overlay__results--active");
        }
        if (idleEl) idleEl.hidden = false;
        if (popularEl && popularEl.children.length) {
            popularEl.hidden = false;
        }
        overlay.classList.add("eq-search-overlay--suggestions-visible");
        if (!overlay.hidden) syncOverlayLayout();
    }

    function openOverlay() {
        if (!overlay.hidden) return;
        if (shouldUseFixedScrollLock() && !scrollCapturedOnTouch) {
            lockedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        }
        scrollCapturedOnTouch = false;
        lastFocused = document.activeElement;
        setOpenState(true);
        showIdleSuggestions();
        if (input) {
            input.value = "";
            input.focus();
        }
        resetClearPosition();
    }

    function closeOverlay() {
        if (overlay.hidden) return;
        setOpenState(false);
        if (input) input.value = "";
        hideSuggestionPanels();
        if (activeRequest && typeof activeRequest.abort === "function") {
            activeRequest.abort();
            activeRequest = null;
        }
        if (lastFocused && typeof lastFocused.focus === "function") {
            lastFocused.focus();
        }
    }

    function resetResults() {
        hideSuggestionPanels();
    }

    function onInputActivate() {
        updateClearVisibility();
        syncClearPosition();
        var term = (input && input.value ? input.value : "").trim();
        if (term.length < 2) {
            showIdleSuggestions();
        } else {
            overlay.classList.add("eq-search-overlay--suggestions-visible");
            fetchSuggestions(term);
        }
    }

    function renderResults(term, products) {
        if (!resultsEl) return;

        var suggestions = buildQuerySuggestions(term, products);
        var hasProducts = products && products.length > 0;
        var hasSuggestions = suggestions.length > 0;

        if (!hasProducts && !hasSuggestions) {
            resultsEl.innerHTML = '<p class="eq-search-overlay__empty">' + escapeHtml(labels.empty) + "</p>";
            resultsEl.hidden = false;
            resultsEl.classList.add("eq-search-overlay__results--active");
            if (idleEl) idleEl.hidden = true;
            overlay.classList.add("eq-search-overlay--suggestions-visible");
            return;
        }

        var suggestionsHtml = "";
        if (hasSuggestions) {
            suggestionsHtml =
                '<div class="eq-search-overlay__col eq-search-overlay__col--suggestions">' +
                '<p class="eq-search-overlay__heading">' +
                escapeHtml(labels.suggestions) +
                "</p>" +
                '<ul class="eq-search-overlay__suggestions">' +
                suggestions
                    .map(function (suggestion) {
                        var href = searchUrl + "?q=" + encodeURIComponent(suggestion) + "&type=product&options%5Bprefix%5D=last";
                        return (
                            "<li>" +
                            '<a class="eq-search-overlay__suggestion" href="' +
                            escapeHtml(href) +
                            '" data-suggestion="' +
                            escapeHtml(suggestion) +
                            '">' +
                            highlightSuggestion(suggestion, term) +
                            "</a>" +
                            "</li>"
                        );
                    })
                    .join("") +
                "</ul>" +
                "</div>";
        }

        var productsHtml = "";
        if (hasProducts) {
            productsHtml =
                '<div class="eq-search-overlay__col eq-search-overlay__col--products">' +
                '<p class="eq-search-overlay__heading">' +
                escapeHtml(labels.products) +
                "</p>" +
                '<ul class="eq-search-overlay__products">' +
                products
                    .slice(0, MAX_PRODUCT_SUGGESTIONS)
                    .map(function (product) {
                        var image = product.image || (product.featured_image && product.featured_image.url) || "";
                        var url = product.url || "#";
                        var title = escapeHtml(product.title || "");
                        return (
                            '<li class="eq-search-overlay__product">' +
                            '<a class="eq-search-overlay__product-link" href="' +
                            escapeHtml(url) +
                            '">' +
                            '<span class="eq-search-overlay__product-media">' +
                            (isOnSale(product) ? '<span class="eq-search-overlay__sale">' + escapeHtml(labels.sale) + "</span>" : "") +
                            (image ? '<img src="' + escapeHtml(image) + '" alt="" width="120" height="120" loading="lazy">' : "") +
                            "</span>" +
                            '<span class="eq-search-overlay__product-info">' +
                            '<span class="eq-search-overlay__product-title">' +
                            title +
                            "</span>" +
                            '<span class="eq-search-overlay__product-price">' +
                            renderPriceHtml(product) +
                            "</span>" +
                            "</span>" +
                            "</a>" +
                            "</li>"
                        );
                    })
                    .join("") +
                "</ul>" +
                '<a class="eq-search-overlay__view-all" href="' +
                escapeHtml(searchUrl + "?q=" + encodeURIComponent(term) + "&type=product&options%5Bprefix%5D=last") +
                '">' +
                escapeHtml(labels.viewAll) +
                "</a>" +
                "</div>";
        } else if (hasSuggestions) {
            productsHtml =
                '<div class="eq-search-overlay__col eq-search-overlay__col--products">' +
                '<p class="eq-search-overlay__heading">' +
                escapeHtml(labels.products) +
                "</p>" +
                '<p class="eq-search-overlay__empty">' +
                escapeHtml(labels.empty) +
                "</p>" +
                "</div>";
        }

        if (!hasSuggestions) {
            suggestionsHtml = '<div class="eq-search-overlay__col eq-search-overlay__col--suggestions eq-search-overlay__col--empty"></div>';
        }

        if (hasProducts || hasSuggestions) {
            resultsEl.innerHTML = '<div class="eq-search-overlay__split">' + suggestionsHtml + productsHtml + "</div>";
        } else {
            resultsEl.innerHTML = '<p class="eq-search-overlay__empty">' + escapeHtml(labels.empty) + "</p>";
        }
        resultsEl.hidden = false;
        resultsEl.classList.add("eq-search-overlay__results--active");
        if (idleEl) idleEl.hidden = true;
        overlay.classList.add("eq-search-overlay--suggestions-visible");
        scheduleOverlayLayoutSync();
    }

    function isSearchableQuery(term) {
        return /[a-z0-9]/i.test(String(term || "").trim());
    }

    function fetchSuggestions(term) {
        if (activeRequest && typeof activeRequest.abort === "function") {
            activeRequest.abort();
        }

        if (!isSearchableQuery(term)) {
            activeRequest = null;
            renderResults(term, []);
            return;
        }

        var controller = window.AbortController ? new AbortController() : null;
        activeRequest = controller;

        var url =
            searchUrl +
            "/suggest.json?q=" +
            encodeURIComponent(term) +
            "&resources[type]=product&resources[limit]=" +
            MAX_PRODUCT_SUGGESTIONS +
            "&resources[options][unavailable_products]=last";

        fetch(url, controller ? { signal: controller.signal } : undefined)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
                renderResults(term, products);
            })
            .catch(function (error) {
                if (error && error.name === "AbortError") return;
                resetResults();
            })
            .finally(function () {
                if (activeRequest === controller) activeRequest = null;
            });
    }

    function onInput() {
        var term = (input && input.value ? input.value : "").trim();
        updateClearVisibility();
        syncClearPosition();
        clearTimeout(debounceTimer);

        if (term.length < 2) {
            showIdleSuggestions();
            return;
        }

        debounceTimer = setTimeout(function () {
            fetchSuggestions(term);
        }, 250);
    }

    if (overlay) {
        overlay.addEventListener("click", function (event) {
            var suggestionLink = event.target.closest("[data-suggestion]");
            if (!suggestionLink || !input) return;
            input.value = suggestionLink.getAttribute("data-suggestion") || input.value;
            updateClearVisibility();
            syncClearPosition();
            onInput();
        });
    }

    openButtons.forEach(function (btn) {
        btn.addEventListener(
            "touchstart",
            function () {
                if (shouldUseFixedScrollLock()) {
                    lockedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
                    scrollCapturedOnTouch = true;
                }
            },
            { passive: true },
        );
        btn.addEventListener("click", function (event) {
            event.preventDefault();
            openOverlay();
        });
    });

    closeButtons.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
            event.preventDefault();
            closeOverlay();
        });
    });

    document.addEventListener("click", function (event) {
        if (overlay.hidden) return;
        if (event.target.closest(".js-eq-search-open")) return;
        if (event.target.closest(".eq-search-overlay__panel")) return;
        closeOverlay();
    });

    if (clearBtnEl) {
        clearBtnEl.addEventListener("click", function (event) {
            event.preventDefault();
            clearSearchInput();
        });
    }

    if (input) {
        input.addEventListener("focus", function () {
            setTypingState(true);
            onInputActivate();
        });
        input.addEventListener("blur", function () {
            setTypingState(false);
        });
        input.addEventListener("click", onInputActivate);
        input.addEventListener("input", onInput);
        input.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                event.preventDefault();
                closeOverlay();
            }
        });
    }

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !overlay.hidden) {
            closeOverlay();
        }
    });

    window.addEventListener(
        "resize",
        function () {
            if (!overlay.hidden) {
                scheduleOverlayLayoutSync();
            }
        },
        { passive: true },
    );

    window.addEventListener(
        "scroll",
        function () {
            if (!overlay.hidden) {
                scheduleOverlayLayoutSync();
            }
        },
        { passive: true },
    );

    initScrollToBlurInput();
})();
/* Eczema - 02 - Optimise Search end */
